module.exports = __webpack_public_path__ + "static/media/seat-participants-icon.ae507dbe.svg";